import { render, staticRenderFns } from "./KnownFor.vue?vue&type=template&id=01f29170"
var script = {}
import style0 from "./KnownFor.vue?vue&type=style&index=0&id=01f29170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports